<div class="search-wrap">
  <form
    autocomplete="off"
    class="search-form"
    name="search-form"
    [style.width]="width"
    (ngSubmit)="onButtonClick(searchTerm)"
  >
    <fd-input-group
      id="search-input"
      placeholder="Search"
      name="search"
      i18n-placeholder="
        XMSG|Placeholder for search input@@organizations.table.searchPlaceholder"
      [disabled]="disabled"
      [button]="true"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onChange($event)"
    >
      @if (isLiveSearch) {
        <button
          fd-button
          (click)="onButtonClick('')"
          class="custom-icon"
          [title]="buttonTooltip"
        >
          <app-icon [icon]="fontAwesomeGlyph"></app-icon>
        </button>
      } @else {
        @if (!!searchTerm || (!searchTerm && lastSearchTermEmitted !== "")) {
          <button
            fd-button
            (click)="onButtonClick('')"
            class="custom-icon"
            title="Clear Search"
          >
            <app-icon icon="xmark"></app-icon>
          </button>
        }
        <button
          fd-button
          (click)="onButtonClick(searchTerm)"
          class="custom-icon"
          title="Search"
        >
          <app-icon icon="magnifying-glass"></app-icon>
        </button>
      }
    </fd-input-group>
  </form>
</div>
